import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const lookup = (obj, path) =>
  path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("osm-lang") || "en");

  useEffect(() => {
    localStorage.setItem("osm-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => lookup(translations[lang], path) ?? lookup(translations.en, path) ?? path;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
